// !This file is intended for JS that should be initialized as quickly as possible on page load. No modules (such as jQuery) are available

// * `config.classes` will not be ready in time, so we unfortunately need this one duplicate
const classes = {
  active: 'tw-on',
}

;(function init() {
  updateGlobalHeaderVars() 

  // updatePersistentConvertVariants() 
  updateYotpoLoyaltyComponents() 
})()


function updateGlobalHeaderVars() {
  // If a storedNavbarHeightVal exists, use that to set --global-navbar-height (reducing layout shift on Desktop)
  let storedNavbarHeightVal = sessionStorage.getItem('css-var--global-navbar-height');
  if (storedNavbarHeightVal === null) return // if *null*, we know nothing exists at that key on sessionStorage
  document.documentElement.style.setProperty('--global-navbar-height', `${parseInt(storedNavbarHeightVal)}px`)
}


function updatePersistentConvertVariants() {
  // * Update Convert Experiences variation-elements
  // * -> Using context from Convert / sessionStorage to provide an immediate value on-load; this value may be updated later in the JS cascade, if new data is returned from Convert

  const selectors = {
    persistentVariationString: 'cnvrt-show-persisting-variant-global-el'
  };

  let storedPersistingVariantParamVal = sessionStorage.getItem(selectors.persistentVariationString);
  let reciprocalPersistingVariantParamVal = storedPersistingVariantParamVal === 'true' ? 'false' : 'true'; // inverting 'true'/'false' strings

  if (storedPersistingVariantParamVal === null) {// if *null*, we know nothing exists at that key on sessionStorage
    if (!window.convert ){
      // No Convert has loaded, default to Original to ensure we don't end up with NO visible elements
      storedPersistingVariantParamVal = 'false'
    } else {
      // Convert has loaded, return early to let convert-experiences.js handle our persisting element
      return;
    }
  } 
    
  // Handle Original + Variant hide/show
  document.body.setAttribute('data-cnvrt-show-persisting-variant-global-el', storedPersistingVariantParamVal)
  let persistingVariant = document.querySelector(`[data-cnvrt-persisting-variant-global-el="${storedPersistingVariantParamVal}"]`)
  let reciprocalVariant = document.querySelector(`[data-cnvrt-persisting-variant-global-el="${reciprocalPersistingVariantParamVal}"]`)

  reciprocalVariant.remove(); // remove element from the DOM
  persistingVariant.classList.add('active-cnvrt-variant'); // reveal element
}


function updateYotpoLoyaltyComponents() {
  // * Update Yotpo Loyalty elements that are contextual to each user
  // * -> Using context from sessionStorage to provide an immediate value on-load; this value may be updated later in the JS cascade, if new data is returned from Yotpo

  const selectors = {
    active: '[data-utility="yotpo-active"]',
    points: '[data-utility="yotpo-points"]',
  }

  // Get available elements
  const pointsEl = document.querySelector(selectors.points)
  const activeEl = document.querySelector(selectors.active)

  // If customer has non-zero points balance in sessionStorage, update available elements
  const points_balance = sessionStorage.getItem('yotpo_points_balance')
  if (points_balance) {

    if (pointsEl) {
      let formattedPointsBalance = formatNumberWithSeparators(points_balance)
      pointsEl.innerText = formattedPointsBalance
    }

    if (activeEl) {
      if (points_balance > 0) {
        activeEl.classList.add(classes.active)
      } else {
        activeEl.classList.remove(classes.active)
      }
    }
  }
}


function formatNumberWithSeparators(numberString) {
  return Number(numberString).toLocaleString(); // toLocaleString provides locale-aware formatting
}